import { organizationSectionEntityName, } from '../../../../../backend/config/classifiers/OrganizationSectionClassifier/shared';
import { organizationTypeEntityName } from '../../../../../backend/config/classifiers/OrganizationTypeClassifier/shared';
import { useContactManagementTranslation } from '../../../../../ui/hooks/useContactManagementTranslation';
import { Form } from '@juvare/common-form-ui/Form';
import { PartialError } from '@juvare/common-web-ui/PartialError';
import { useStorageGet, useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
import { Alert, CircularProgress } from '@mui/material';
import React from 'react';
import { useOrganization } from '../../hooks/useOrganization';
import { OrganizationMembers } from '../OrganizationsPanel/components/OrganizationMembers';
export const OrganizationSectionComponent = (props) => {
    var _a;
    const organizationResponse = useOrganization(props.organizationId);
    const handleReloadOrganization = organizationResponse.mutate;
    const { t } = useContactManagementTranslation();
    const { data: organizationTypes, isLoading: organizationTypesIsLoading } = useStorageList(organizationTypeEntityName, {
        filter: [
            {
                column: 'status',
                op: '=',
                value: 'active',
            },
        ],
        limit: 1,
    });
    const formParams = {
        id: props.organizationId,
        organizationsTypeLength: (_a = organizationTypes === null || organizationTypes === void 0 ? void 0 : organizationTypes.total) !== null && _a !== void 0 ? _a : 0,
    };
    const { data: organizationSectionResponse, error, isLoading: organizationSectionIsLoading, } = useStorageGet(organizationSectionEntityName, props.section.id);
    const isLoading = organizationSectionIsLoading || organizationTypesIsLoading;
    if (props.section.columns.key === 'members') {
        if (!props.organizationId) {
            return null;
        }
        return (React.createElement(OrganizationMembers, { organizationId: props.organizationId, onReloadOrganization: handleReloadOrganization, customMemberDetailsComponent: props.customMemberDetailsComponent }));
    }
    if (!isLoading && !(organizationSectionResponse === null || organizationSectionResponse === void 0 ? void 0 : organizationSectionResponse.data.form)) {
        return React.createElement(Alert, { color: 'error' }, t('panels.organizations.invalidSectionConfig'));
    }
    if (organizationSectionResponse && !error) {
        return (React.createElement(OrganizationSectionForm, { organizationData: props.organizationData, parentId: props.parentId, section: organizationSectionResponse.data, showSubmitButton: props.showSubmitButton, formParams: formParams, onChanged: props.onChanged, onSubmit: props.onSubmit, onSubmitSuccess: props.onSubmitSuccess }));
    }
    else if (isLoading && !organizationSectionResponse) {
        return React.createElement(CircularProgress, null);
    }
    else if (!organizationSectionResponse && error) {
        return React.createElement(PartialError, { error: error });
    }
    return React.createElement(React.Fragment, null);
};
const OrganizationSectionForm = (props) => {
    return (React.createElement(Form, { config: props.section.form, data: Object.assign(Object.assign({}, props.organizationData), { parentId: props.parentId }), formParams: props.formParams, hideFormControls: !props.showSubmitButton, onChanged: props.onChanged, changeUndefinedTopFieldsToNull: true, onSubmit: props.onSubmit, onSubmitSuccess: props.onSubmitSuccess }));
};
